import { Injectable, ErrorHandler } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { FileExtension, IFileUploadMetadata } from '../models';
import { CommonConstants, FileConstants } from 'src/app/shared/constant';
import { Headers } from '../interceptors/token.interceptor';
import { Observable } from 'rxjs';

@Injectable()
export class FileService extends ApiService {
  private readonly fileExtensionsAttachment: FileExtension[] = [];

  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
    this.fileExtensionsAttachment.push(new FileExtension('jpg', 'JPG'));
    this.fileExtensionsAttachment.push(new FileExtension('jpeg', 'JPEG'));
    this.fileExtensionsAttachment.push(new FileExtension('png', 'PNG'));
  }

  public viewAttachmentUrl(identifier: string) {
    if (identifier === CommonConstants.EMPTY_GUID) {
      return;
    }
    const url = this.path('files/viewFile');
    return url + `?diskIdentifier=${identifier}`;
  }

  public uploadFiles(files, metadata: IFileUploadMetadata) {
    const formData = new FormData();

    for (let j = 0; j < files.length; j++) {
      const upload = files[j];
      formData.append(upload.name, upload);
    }

    formData.append('metadata', JSON.stringify(metadata));
    const headers = {};
    headers[Headers.SKIP_INTERCEPTOR_HEADERS] = 'yes';
    const url = this.path('files/uploadFile');
    return this.http.post<any>(url, formData, { headers });
  }

  public isValidAttachmentExtension(file: string) {
    return this.fileExtensionsAttachment.some(
      (ext) => '.' + ext.extension.toLowerCase() === (file || '').toLowerCase()
    );
  }

  public isValidSize(files): boolean {
    for (const file of files) {
      if (file.size > FileConstants.fileSizeLimit) {
        return false;
      }
    }
    return true;
  }

  public getAllFiles(): Observable<any[]> {
    return this.get(`file`);
  }
}
